<template>
  <div :class="{ gray_: gary }">
    <router-view />
  </div>
</template>

<script setup>
import { getclose, getColor,getinit } from "@/api/api";
import { ref } from "vue";
import router from "@/router/index.js";

const gary = ref(false);
gary.value = localStorage.getItem("color_style") || false;
const getColors = async () => {
  const res = await getColor();
  if (res.data && Number(res.data) === 1) {
    gary.value = true;
  } else {
    gary.value = false;
  }
  localStorage.setItem("color_style", gary.value);
};
getColors();

const getPageShow = async () => {
  const res2 = await getclose();
  localStorage.setItem("open_pages", res2.data);
};
getPageShow();

const gettoinit = async () => {
  const res3 = await getinit();
  localStorage.setItem("beian", res3.data.config.site.beian);
};
gettoinit();

router.beforeEach((to, from, next) => {
  const open = localStorage.getItem("open_pages") || 0; 
  if ((to.name === 'index' || to.name === 'list' || to.name === 'content') && open == 1) {  
    next({ path: "/close" });   
  } else {  
    next();   
  }  
  // if (open !== 0) {
  //   router.replace("/close")
  // } else {
  //   next()
  // }
})
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

.gray_ {
  filter: grayscale(100%);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;
    text-decoration: none;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
